import React, { useEffect, useState } from "react";
import { get } from "../../../../../modules/get.js";
import { useGlobalUpdate, } from "../../scripts/useGlobalUpdate.js";
import BucketContainer from "../bucketContainer/bucketContainer.js";
import NavbarLeft from "../nav-left/nav-left.js";
import NavRight from "../nav-right/nav-right.js";
import "./style.css";
export const UpdateBasketItemsCount = {
    listeners: [],
    name: "update-basket-items-count",
    state: 0,
};
export default function Navbar(props) {
    const [isBucketOpen, setBucketOpen] = useState(false);
    const [basketCount, setBasketCount] = useState(undefined);
    const [update, setUpdate] = useState(0);
    const { useListener } = useGlobalUpdate(UpdateBasketItemsCount);
    useListener(setUpdate);
    useEffect(() => {
        get("/api/public/clients/basket/count").then((res) => {
            if (res.status !== 200) {
                setBasketCount(undefined);
                return;
            }
            setBasketCount(res.count);
        });
    }, [update]);
    return (React.createElement("div", { className: "nav-container" },
        React.createElement(BucketContainer, { isOpen: isBucketOpen, closeBucket: () => setBucketOpen(false), onSetOpen: () => setBucketOpen(true) }),
        React.createElement(NavbarLeft, null),
        React.createElement(NavRight, { onBucketOpenRequest: () => setBucketOpen(!isBucketOpen), isBucketOpen: isBucketOpen, itemsCount: basketCount })));
}
